/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2022-08-06 21:35:03
 */
import request from './request';

// 获取课程列表
export function getCourseList(params) {
  return request('/lesson/list', {
    method: 'GET',
    params
  });
}
// 获取课程详情
export function getCourseByID(id) {
  return request('/lesson/details', {
    method: 'GET',
    params: {
      id
    }
  });
}
// 关注/取消关注课程
export function followCourse(id) {
  return request(`/lesson/follow?id=${id}`, {
    method: 'POST'
  });
}
// 戳一戳
export function urgeReq(id) {
  return request(`/lesson/wantToSee?id=${id}`);
}
// 获取热门课程
export function getHotCourseList() {
  return request(`/lesson/hot/list`);
}